import React, {Suspense, lazy} from "react";
import { Switch, Route } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Sidebar from "components/Sidebar/Sidebar.js";
import Spinner from "components/Spinner";
import Navbar from "components/Navbars";

import dashboardRoutes from 'router/dashboard'
import styles from "assets/jss/layouts/adminStyle.js";

const Overview = lazy(() => import('views/Overview'));


const switchRoutes = (
  <Switch>
    <Suspense fallback={<Spinner />}>
      <Route
        path={"/project/:name/overview"}
        component={Overview}
      />

      {dashboardRoutes.map((prop, key) => {
        if (prop.collapse)
          return prop.views.map((prop2, key) => {
            return <Route path={prop2.path} render={props => <prop2.component {...props} pageName={[prop.name,prop2.name]}/>} key={key}/>
          })
        return <Route path={prop.path} render={props => <prop.component {...props} pageName={[prop.name]}/>} key={key}/>
      })}
    </Suspense>
  </Switch>
);

const useStyles = makeStyles(styles);

/**
 * @return {null}
 */

export default function Index({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className={classes.wrapper}>
      <Navbar
        routes={dashboardRoutes}
        handleDrawerToggle={handleDrawerToggle}
      />
      <Sidebar
        routes={dashboardRoutes}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <div className={classes.content}>
          <div className={classes.container}>{switchRoutes}</div>
        </div>
      </div>
    </div>
  );
}
